import { TRASH_DIR, type SyncFs } from '../folderSync/reconcile';
import type { NativeShell } from './bridge';

/**
 * The shell's document folder as a folder the sync can work with.
 *
 * This is what keeps a native build honest: inside a WKWebView, IndexedDB is
 * storage the system may reclaim under pressure — survivable for one draft,
 * fatal for a vault. With this, every note is also a real `.md` file in the
 * app's own document directory, written by the same reconciler that syncs a
 * folder on the desktop. The webview database becomes a cache of something
 * durable rather than the only copy.
 */
export function nativeVaultFs(shell: NativeShell): SyncFs {
  const { files } = shell;
  const stamp = () => new Date().toISOString().replace(/[:.]/g, '-');

  return {
    list: () => files.list(),
    read: (path) => files.read(path),
    write: (path, text) => files.write(path, text),
    async trash(path) {
      // Copy first, delete second: a failure in between leaves the note twice,
      // never zero times.
      const text = await files.read(path);
      await files.write(`${TRASH_DIR}/${stamp()}/${path}`, text);
      await files.remove(path);
    },
    remove: (path) => files.remove(path),
  };
}
